document.addEventListener("DOMContentLoaded", function () {
  // Main elements
  const slidesContainer = document.querySelector(".carousel-slides");
  const slides = document.querySelectorAll(".slide");
  const indicators = document.querySelectorAll(".indicator");
  const prevBtn = document.querySelector(".prev-btn");
  const nextBtn = document.querySelector(".next-btn");
  const currentSlideEl = document.querySelector(".current-slide");
  const totalSlidesEl = document.querySelector(".total-slides");
  const scrubberTrack = document.querySelector(".scrubber-track");
  const scrubberProgress = document.querySelector(".scrubber-progress");
  const scrubberThumb = document.querySelector(".scrubber-thumb");

  // Variables
  let currentIndex = 0;
  const slideCount = slides.length;
  let autoScrollInterval;
  let isDragging = false;
  let startX, startPos;

  // Setup
  totalSlidesEl.textContent = slideCount;

  // Start auto-scrolling
  function startAutoScroll() {
    clearInterval(autoScrollInterval); // Clear any existing interval
    autoScrollInterval = setInterval(function () {
      goToSlide((currentIndex + 1) % slideCount);
    }, 5000); // Change slide every 5 seconds
  }

  // Initialize auto-scroll
  startAutoScroll();

  // Go to specific slide
  function goToSlide(index) {
    slidesContainer.style.transform = `translateX(-${index * 100}%)`;
    currentIndex = index;
    updateIndicators();
    updatePagination();
    updateScrubber();
  }

  // Update indicators
  function updateIndicators() {
    indicators.forEach((indicator, index) => {
      indicator.classList.toggle("active", index === currentIndex);
    });
  }

  // Update pagination
  function updatePagination() {
    currentSlideEl.textContent = currentIndex + 1;
  }

  // Update scrubber
  function updateScrubber() {
    const progress = (currentIndex / (slideCount - 1)) * 100;
    scrubberProgress.style.width = `${progress}%`;
    scrubberThumb.style.left = `${progress}%`;
  }

  // Previous slide
  prevBtn.addEventListener("click", function () {
    goToSlide((currentIndex - 1 + slideCount) % slideCount);
    resetAutoScroll();
  });

  // Next slide
  nextBtn.addEventListener("click", function () {
    goToSlide((currentIndex + 1) % slideCount);
    resetAutoScroll();
  });

  // Indicator click
  indicators.forEach((indicator, index) => {
    indicator.addEventListener("click", function () {
      goToSlide(index);
      resetAutoScroll();
    });
  });

  // Scrubber track click
  scrubberTrack.addEventListener("click", function (e) {
    if (isDragging) return;

    const rect = scrubberTrack.getBoundingClientRect();
    const position = (e.clientX - rect.left) / rect.width;
    const slideIndex = Math.round(position * (slideCount - 1));

    goToSlide(slideIndex);
    resetAutoScroll();
  });

  // Scrubber thumb drag - mouse events
  scrubberThumb.addEventListener("mousedown", function (e) {
    startDrag(e.clientX);
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", stopDrag);
    e.preventDefault();
  });

  // Scrubber thumb drag - touch events
  scrubberThumb.addEventListener("touchstart", function (e) {
    startDrag(e.touches[0].clientX);
    document.addEventListener("touchmove", onTouchMove);
    document.addEventListener("touchend", stopDrag);
  });

  function startDrag(clientX) {
    isDragging = true;
    startX = clientX;
    startPos =
      (parseFloat(scrubberThumb.style.left || 0) / 100) *
      scrubberTrack.offsetWidth;
    clearInterval(autoScrollInterval);
  }

  function onMouseMove(e) {
    if (!isDragging) return;
    updateDrag(e.clientX);
  }

  function onTouchMove(e) {
    if (!isDragging) return;
    updateDrag(e.touches[0].clientX);
  }

  function updateDrag(clientX) {
    const delta = clientX - startX;
    const trackWidth = scrubberTrack.offsetWidth;
    let newPos = startPos + delta;

    // Constrain to track
    newPos = Math.max(0, Math.min(newPos, trackWidth));

    const percent = (newPos / trackWidth) * 100;
    scrubberProgress.style.width = `${percent}%`;
    scrubberThumb.style.left = `${percent}%`;
  }

  function stopDrag() {
    if (!isDragging) return;

    isDragging = false;
    document.removeEventListener("mousemove", onMouseMove);
    document.removeEventListener("mouseup", stopDrag);
    document.removeEventListener("touchmove", onTouchMove);
    document.removeEventListener("touchend", stopDrag);

    // Calculate which slide to go to
    const percent = parseFloat(scrubberThumb.style.left) / 100;
    const slideIndex = Math.round(percent * (slideCount - 1));

    goToSlide(slideIndex);
    startAutoScroll();
  }

  // Reset auto-scroll timer
  function resetAutoScroll() {
    clearInterval(autoScrollInterval);
    startAutoScroll();
  }

  // Pause auto-scroll on hover
  slidesContainer.addEventListener("mouseenter", function () {
    clearInterval(autoScrollInterval);
  });

  // Resume auto-scroll when mouse leaves
  slidesContainer.addEventListener("mouseleave", function () {
    if (!isDragging) {
      startAutoScroll();
    }
  });

  // Initial setup
  updateScrubber();
});
